import { umbracoApi } from "~/utils/axios.util";

export interface PlayPinParams {
    Typen_facet?: string;
    Plaatsen_facet?: string;
    Wijken_facet?: string;
    Wijkengemeenten_facet?: string;
}

export interface IInteractieveKaartPin {
    Id: string;
    Title: string;
    Address: string;
    Type: string;
    Kind: string;
    Latitude: number;
    Longitude: number;
    GpxUrl: string
    GpxXml: string;
    DisplayLabel: string;
    ImageUrl: string;
    InfoUrl: string;
}

export interface IInteractieveKaartPinDetail {
    Id: string;
    Title: string;
    Address: string | null;
    Description: string | null;
    Type: string;
    Kind: string;
    Latitude: number;
    Longitude: number;
    GpxUrl: string | null;
    GpxXml: string | null;
    ImageUrl: string | null;
    InfoUrl: string | null;
    DisplayLabel: string;
    RouteDistance: number | null;
    RouteInspanning: string[];
    RouteTerreintype: string[];
}

export interface IInteractieveKaartFacetItem {
    Label: string;
    Count: number;
}

export interface IInteractieveKaartFacetGroup {
    GroupName: string;
    TotalCount: number;
    TotalChildren: number;
    Facets: IInteractieveKaartFacetItem[];
}

export interface IInteractieveKaartSearchResult {
    Items: IInteractieveKaartPin[];
    Count: number;
    Facets: IInteractieveKaartFacetGroup[];
}

const getPlayPins = async (interactieveKaartId: string): Promise<IInteractieveKaartSearchResult> => {
    const response = await umbracoApi.get<IInteractieveKaartSearchResult>(`interactieve-kaart/${interactieveKaartId}/pins/search`);
    return response.data;
};

const getPlayPinById = async (interactieveKaartId: string, pinId: string): Promise<IInteractieveKaartPinDetail> => {
    const response = await umbracoApi.get<IInteractieveKaartPinDetail>(`interactieve-kaart/${interactieveKaartId}/pins/${pinId}`);
    return response.data;
};

export default { getPlayPins, getPlayPinById };

